@if (open) {
  <div
    class="modal-overlay fixed inset-0 z-50 flex items-center justify-center p-4 bg-[rgba(15,23,42,0.55)]"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="title"
    (click)="onBackdropClick()"
  >
    <div
      #panel
      tabindex="-1"
      class="modal-panel w-full rounded-lg bg-white shadow-2xl outline-none relative"
      [ngClass]="{
        'md:min-w-3xl min-h-52 max-h-[calc(100vh-2rem)] overflow-auto':
          size !== 'full' && size !== '2xl-full-h',
        'max-w-sm': size === 'sm',
        'max-w-md': size === 'md',
        'max-w-3xl': size === 'lg',
        'max-w-5xl': size === 'xl',
        'max-w-7xl': size === '2xl',
        'max-w-7xl min-h-[90vh] max-h-[90vh] overflow-y-auto overflow-x-hidden':
          size === '2xl-full-h',
        'w-[95vw] h-[90vh] max-w-none flex flex-col overflow-hidden': size === 'full',
      }"
      (click)="$event.stopPropagation()"
    >
      <div
        class="modal-header sticky top-0 z-20 shrink-0 flex items-center justify-between gap-3 bg-gradient-primary px-4 py-4 rounded-tl-lg rounded-tr-lg"
      >
        <h2 class="modal-title text-lg font-semibold text-gray-900 text-white">
          {{ title }}
        </h2>
        @if (showCloseButton) {
          <button
            type="button"
            class="modal-close text-gray-400 hover:text-white text-2xl transition-colors mr-2 -mt-1"
            aria-label="Close modal"
            (click)="close('button')"
          >
            ×
          </button>
        }
      </div>

      <div
        class="modal-content"
        [ngClass]="size === 'full' ? 'flex-1 min-h-0 overflow-hidden' : 'px-4 py-4'"
      >
        <ng-content></ng-content>
      </div>

      <!--	  <div class="modal-footer flex justify-end gap-3 border-t border-gray-200 px-4 py-3">-->
      <!--      <ng-content select="[data-modal-footer]"></ng-content>-->
      <!--&lt;!&ndash;      <ng-content select="[modal-footer]"></ng-content>&ndash;&gt;-->
      <!--	  </div>-->
    </div>
  </div>
}
